<template>
  <el-form>
    <div class="row">
      <div class="col-md-8 col-12">
        <el-form-item
          :label="L10n('search')"
          class="material-style"
        >
          <select-rfq-2
            :value="rfq2ID"
            @update:value="$emit('update:rfq2ID', $event)"
          />
        </el-form-item>
      </div>
      <div class="col-md-4 col-12 d-flex justify-content-end align-items-center">
        <button
          type="button"
          class="btn btn-size-s btn-mobile-full"
          @click="handleAddNew">
          <i class="fas fa-plus"/> {{L10n('add-a-quote')}}
        </button>
      </div>
    </div>
  </el-form>
</template>

<script>
export default {
  name: 'ToolsPanel',
  components: {
    'select-rfq-2': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectRFQ2s')
  },
  props: {
    rfq2ID: { required: true }
  },
  methods: {
    handleAddNew () {
      this.$emit('onAddNew')
    }
  }
}
</script>
